import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

import { AccordionModule } from '@openng/optimus-ui/accordion'
import { AutoCompleteModule } from '@openng/optimus-ui/autocomplete'
import { AvatarModule } from '@openng/optimus-ui/avatar'
import { AvatarGroupModule } from '@openng/optimus-ui/avatargroup'
import { BadgeModule } from '@openng/optimus-ui/badge'
import { BlockUIModule } from '@openng/optimus-ui/blockui'
import { BreadcrumbModule } from '@openng/optimus-ui/breadcrumb'
import { ButtonModule } from '@openng/optimus-ui/button'
import { ButtonGroupModule } from '@openng/optimus-ui/buttongroup'
import { CardModule } from '@openng/optimus-ui/card'
import { CarouselModule } from '@openng/optimus-ui/carousel'
import { CascadeSelectModule } from '@openng/optimus-ui/cascadeselect'
import { CheckboxModule } from '@openng/optimus-ui/checkbox'
import { ChipModule } from '@openng/optimus-ui/chip'
import { ColorPickerModule } from '@openng/optimus-ui/colorpicker'
import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog'
import { ConfirmPopupModule } from '@openng/optimus-ui/confirmpopup'
import { ContextMenuModule } from '@openng/optimus-ui/contextmenu'
import { DataViewModule } from '@openng/optimus-ui/dataview'
import { DatePickerModule } from '@openng/optimus-ui/datepicker'
import { DialogModule } from '@openng/optimus-ui/dialog'
import { DividerModule } from '@openng/optimus-ui/divider'
import { DockModule } from '@openng/optimus-ui/dock'
import { DrawerModule } from '@openng/optimus-ui/drawer'
import { DynamicDialogModule } from '@openng/optimus-ui/dynamicdialog'
import { EditorModule } from '@openng/optimus-ui/editor'
import { FieldsetModule } from '@openng/optimus-ui/fieldset'
import { FileUploadModule } from '@openng/optimus-ui/fileupload'
import { FloatLabelModule } from '@openng/optimus-ui/floatlabel'
import { FocusTrapModule } from '@openng/optimus-ui/focustrap'
import { GalleriaModule } from '@openng/optimus-ui/galleria'
import { IconFieldModule } from '@openng/optimus-ui/iconfield'
import { IftaLabelModule } from '@openng/optimus-ui/iftalabel'
import { ImageModule } from '@openng/optimus-ui/image'
import { ImageCompareModule } from '@openng/optimus-ui/imagecompare'
import { InplaceModule } from '@openng/optimus-ui/inplace'
import { InputGroupModule } from '@openng/optimus-ui/inputgroup'
import { InputGroupAddonModule } from '@openng/optimus-ui/inputgroupaddon'
import { InputIconModule } from '@openng/optimus-ui/inputicon'
import { InputMaskModule } from '@openng/optimus-ui/inputmask'
import { InputNumberModule } from '@openng/optimus-ui/inputnumber'
import { InputOtpModule } from '@openng/optimus-ui/inputotp'
import { InputTextModule } from '@openng/optimus-ui/inputtext'
import { KeyFilterModule } from '@openng/optimus-ui/keyfilter'
import { KnobModule } from '@openng/optimus-ui/knob'
import { ListboxModule } from '@openng/optimus-ui/listbox'
import { MegaMenuModule } from '@openng/optimus-ui/megamenu'
import { MenuModule } from '@openng/optimus-ui/menu'
import { MenubarModule } from '@openng/optimus-ui/menubar'
import { MessageModule } from '@openng/optimus-ui/message'
import { MeterGroupModule } from '@openng/optimus-ui/metergroup'
import { MultiSelectModule } from '@openng/optimus-ui/multiselect'
import { OrderListModule } from '@openng/optimus-ui/orderlist'
import { OrganizationChartModule } from '@openng/optimus-ui/organizationchart'
import { OverlayBadgeModule } from '@openng/optimus-ui/overlaybadge'
import { PaginatorModule } from '@openng/optimus-ui/paginator'
import { PanelModule } from '@openng/optimus-ui/panel'
import { PanelMenuModule } from '@openng/optimus-ui/panelmenu'
import { PasswordModule } from '@openng/optimus-ui/password'
import { PickListModule } from '@openng/optimus-ui/picklist'
import { PopoverModule as OptimusPopoverModule } from '@openng/optimus-ui/popover'
import { ProgressBarModule } from '@openng/optimus-ui/progressbar'
import { ProgressSpinnerModule } from '@openng/optimus-ui/progressspinner'
import { RadioButtonModule } from '@openng/optimus-ui/radiobutton'
import { RatingModule } from '@openng/optimus-ui/rating'
import { RippleModule } from '@openng/optimus-ui/ripple'
import { ScrollerModule } from '@openng/optimus-ui/scroller'
import { ScrollPanelModule } from '@openng/optimus-ui/scrollpanel'
import { ScrollTopModule } from '@openng/optimus-ui/scrolltop'
import { SelectModule } from '@openng/optimus-ui/select'
import { SelectButtonModule } from '@openng/optimus-ui/selectbutton'
import { SkeletonModule } from '@openng/optimus-ui/skeleton'
import { SliderModule } from '@openng/optimus-ui/slider'
import { SpeedDialModule } from '@openng/optimus-ui/speeddial'
import { SplitButtonModule } from '@openng/optimus-ui/splitbutton'
import { SplitterModule } from '@openng/optimus-ui/splitter'
import { StepsModule } from '@openng/optimus-ui/steps'
import { StepperModule } from '@openng/optimus-ui/stepper'
import { StyleClassModule } from '@openng/optimus-ui/styleclass'
import { TableModule } from '@openng/optimus-ui/table'
import { TabsModule } from '@openng/optimus-ui/tabs'
import { TagModule } from '@openng/optimus-ui/tag'
import { TerminalModule } from '@openng/optimus-ui/terminal'
import { TieredMenuModule } from '@openng/optimus-ui/tieredmenu'
import { TimelineModule } from '@openng/optimus-ui/timeline'
import { ToastModule } from '@openng/optimus-ui/toast'
import { ToggleButtonModule } from '@openng/optimus-ui/togglebutton'
import { ToggleSwitchModule } from '@openng/optimus-ui/toggleswitch'
import { ToolbarModule } from '@openng/optimus-ui/toolbar'
import { TooltipModule as OptimusTooltipModule } from '@openng/optimus-ui/tooltip'
import { TreeModule } from '@openng/optimus-ui/tree'
import { TreeSelectModule } from '@openng/optimus-ui/treeselect'
import { TreeTableModule } from '@openng/optimus-ui/treetable'

import { FuseqTableComponent } from '../FuseQ/fuseq-modules/fuseqTable/fqtable.component'
import { FilterPipe } from '../_pipe/filterText.pipe'

const OPTIMUS_UI_MODULES = [
  AccordionModule, AutoCompleteModule, AvatarModule, AvatarGroupModule, BadgeModule, BlockUIModule,
  BreadcrumbModule, ButtonModule, ButtonGroupModule, CardModule, CarouselModule,
  CascadeSelectModule, CheckboxModule, ChipModule, ColorPickerModule, ConfirmDialogModule,
  ConfirmPopupModule, ContextMenuModule, DataViewModule, DatePickerModule, DialogModule,
  DividerModule, DockModule, DrawerModule, DynamicDialogModule, EditorModule, FieldsetModule,
  FileUploadModule, FloatLabelModule, FocusTrapModule, GalleriaModule, IconFieldModule,
  ImageModule, ImageCompareModule, InplaceModule, InputGroupModule, InputGroupAddonModule,
  IftaLabelModule, InputIconModule, InputMaskModule, InputNumberModule, InputOtpModule, InputTextModule,
  KeyFilterModule, KnobModule, ListboxModule, MegaMenuModule, MenuModule, MenubarModule,
  MessageModule, MeterGroupModule, MultiSelectModule, OrderListModule, OrganizationChartModule,
  OverlayBadgeModule, PaginatorModule, PanelModule, PanelMenuModule, PasswordModule, PickListModule,
  OptimusPopoverModule, ProgressBarModule, ProgressSpinnerModule, RadioButtonModule, RatingModule,
  RippleModule, ScrollerModule, ScrollPanelModule, ScrollTopModule, SelectModule, SelectButtonModule,
  SkeletonModule, SliderModule, SpeedDialModule, SplitButtonModule, SplitterModule, StepsModule,
  StepperModule, StyleClassModule, TableModule, TabsModule, TagModule, TerminalModule, TieredMenuModule,
  TimelineModule, ToastModule, ToggleButtonModule, ToggleSwitchModule, ToolbarModule, OptimusTooltipModule,
  TreeModule, TreeSelectModule, TreeTableModule
]

@NgModule({
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule,
    ...OPTIMUS_UI_MODULES,
    FuseqTableComponent,
    FilterPipe
  ],
  exports: [
    CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule,
    ...OPTIMUS_UI_MODULES,
    FuseqTableComponent,
    FilterPipe
  ]
})
export class OptimUiSharedModule {}
